// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Properties from "../../Properties";
import { putInit } from "../../global/types/constants";
import SingleTextField from "../../global/components/SingleTextField";
import SingleSelect from "../../global/components/SingleSelect";
import type { SingleInlineEditorStatesType, SingleInlineEditorPropsType } from "../types/UserFormType";
import { updateUser } from "../../global/actions/databaseActions";
import LoadingProgress from "../../global/components/LoadingProgress";
import { ColorSchema } from "../../global/types/scss";
import { buttonStyles } from "../../global/components/StyledButtons";
import { getCookie } from "../../global/functions/cookies";

import { InlineEditStateless } from "@atlaskit/inline-edit";
import ToolTip from "@atlaskit/tooltip";

import ErrorIcon from "@material-ui/icons/Error";
import DoneIcon from "@material-ui/icons/Done";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";

class SingleInlineEditor extends Component<SingleInlineEditorPropsType, SingleInlineEditorStatesType> {
  constructor(props: SingleInlineEditorPropsType) {
    super(props);
    this.updateChange = this.updateChange.bind(this);
    this.state = {
      textInputVal: props.value || "",
      initalVal: props.value || "",
      isEditing: false,
      loading: false
    };
  }

  componentWillReceiveProps(nextProps: SingleInlineEditorPropsType) {
    this.setState({ textInputVal: nextProps.value, initalVal: nextProps.value });
  }

  updateChange = async (): * => {
    const value = this.state.textInputVal;
    const field = this.props.field;
    //const uuid = this.props.user.uuid;
    if (value === this.state.initalVal) {
      this.cancelUpdate();
    }
    else {
      this.setState({ loading: true });
      const postFormData = new FormData();
      postFormData.append(field, value);
      const accessToken = getCookie("access_token");
      const res: Response = await fetch(`${Properties.api_root}/api/v2/conferences/${this.props.db.conference.id}/people/${accessToken}`, putInit(postFormData));

      if (res.ok) {
        this.setState({ isEditing: false, initalVal: value, loading: false });
        this.props.actions.updateUser(field, value);
      } else {
        this.props.setUpdateError(field + " update failed, please try again later.");
      }
    }
  }

  cancelUpdate = (): * => {
    this.setState({ textInputVal: this.state.initalVal, isEditing: false });
  }

  render(): React$Element<*> {
    const color = this.props.classes.shineIcon;
    return (
      <ToolTip content={this.props.tooltip} position="top" hideTooltipOnClick={true}>
        <InlineEditStateless
          label=""
          isLabelHidden={true}
          isEditing={this.state.isEditing}
          isConfirmOnBlurDisabled={false}
          areActionButtonsHidden={true}
          isFitContainerWidthReadView={true}
          disableEditViewFieldBase={true}
          onEditRequested={() => this.setState({ isEditing: true })}
          editView={
            <div style={{ position: "relative" }}>
              {this.props.menus &&
                <SingleSelect
                  isRequired={true}
                  label=""
                  name={this.props.field}
                  value={this.state.textInputVal}
                  onChange={e => this.setState({ textInputVal: e.target.value })}
                  menus={this.props.menus}
                  inputClass="short"
                  rootClass="fixed-select-root"
                />
              ||
                <SingleTextField
                  isRequired={true}
                  label=""
                  name={this.props.field}
                  value={this.state.textInputVal}
                  onChange={e => this.setState({ textInputVal: e.target.value })}
                  inpuType={this.props.type === "DATE" ? "date" : "text"}
                  isAutoFocus={true}
                  onEnter={this.updateChange}
                  inputClass="short"
                />
              }
              {this.state.loading &&
                (<LoadingProgress size={18} style={{ position: "absolute" }} />)
                ||
                (
                  <div className="inline-btns">
                    <IconButton color="primary" onClick={this.cancelUpdate} className="edit-btn"><CloseIcon className={color} /></IconButton>
                    <IconButton color="primary" onClick={this.updateChange} className="edit-btn"><DoneIcon className={color} /></IconButton>
                  </div>
                )
              }
            </div>
          }
          readView={
            <span style={{ color: ColorSchema("primary") }}>{this.state.textInputVal}</span>
          }
          onConfirm={this.updateChange}
          onCancel={this.cancelUpdate}
        />
      </ToolTip>
    );
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ updateUser }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(buttonStyles)(SingleInlineEditor));



// WEBPACK FOOTER //
// ./src/conference/component/SingleInlineEditor.js